import { Box, Tooltip, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import StatusIndicatorSmall from "../StatusIndicatorSmall";
import ProgressBar from "../ProgressBar";
import { useTranslation } from "react-i18next";
import { AvatarAndName } from "../AvatarAndName";
import { colors } from "../../common/pallette/colors";
import './styles.css';
import SubGoalsTable from "../SubGoalsTable";
import { useDispatch, useSelector } from "react-redux";
import { resetSelectedSubGoal, setGoals, setSelectedGoal, setSelectedSubGoal } from "../../redux/reducers/goalsAndStrategy";
import { useNavigate } from "react-router";
import NewAcademySubGoalPopper from "../../containers/NewAcademySubGoalPopper";
import { calculateGoalProgress, formatToYear, getAverageProjectStatus } from "../../common/StaticExports";
import { baseUrl } from "../../api/config";
import ButtonDefault from "../ButtonDefault";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCirclePlus, faLock, faLockOpen, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { deleteGoal, getGoalDetail } from "../../api/goals";
import { resetSelectedProject } from "../../redux/reducers/actionPlan";
import CircularWithValueLabel from "../CircularProgress";
import { getClubDepartments } from "../../api/club";
import { setDepartmentList } from "../../redux/reducers/evaluation";
import logo from '../../assets/icons/JLogo.svg'

export const GoalCard = (props:any) => {
    const { data, isSubGoal } = props;
    const [t] = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [addSubGoal, setAddSubGoal] = useState(false);
    const goals = useSelector((state:any) => state.goalsAndStrategy.goals);
    const departmentList = useSelector((state:any) => state.evaluation.departmentList);
    const clubDetails = useSelector((state:any) => state.clubDetails);
    const isAdmin = useSelector((state:any) => state.common.isAdmin);
    const currentClub = useSelector((state: any) => state.clubDetails);

    const statuses = data?.subGoals ? data?.subGoals.map((item:any) => item?.status) : [];

    const manageDeleteGoal = async () => {
        await deleteGoal({ goalId: data.id });
        const tempGoals = goals?.filter((item:any) => item.id !== data.id);
        dispatch(setGoals(tempGoals));
    }

    const manageCloseAddSubGoalPopper = (newSubGoal:any, updated:any) => {
        setAddSubGoal(false);
        if (newSubGoal != null && updated) {
            const tempObj = {...data, subGoals: data?.subGoals?.length > 0 ? [...data?.subGoals, newSubGoal] : [newSubGoal]};
            const tempGoals = goals?.map((item:any) => item?.id == data?.id ? tempObj : item);
            dispatch(setGoals(tempGoals));
        }
    }

    const fetchDepartmentName = (deptIdOrName:any) => {
        if (isNaN(deptIdOrName)) {
            return deptIdOrName;
        } else {
            const dept = departmentList?.find((item:any) => item.id == deptIdOrName);
            return dept ? dept.name : '_';
        }
    }

    
    const fetchDepartmentList = async () => {
        const response = await getClubDepartments({ clubId: clubDetails?.id });
        dispatch(setDepartmentList(response));
    }

    useEffect(() => {
        clubDetails && clubDetails?.id &&
        (!departmentList || departmentList.length == 0) &&
        fetchDepartmentList();
    }, [clubDetails]);

    return (
        <>
            <NewAcademySubGoalPopper isOpen={addSubGoal} handleClickAway={manageCloseAddSubGoalPopper} parentGoal={data} />
            <Box
            className={'goalCardContainer hoverBGlite'} 
            onClick={(e:any) => {
                e.stopPropagation();
                dispatch(resetSelectedProject());
                if (isSubGoal) {
                    dispatch(setSelectedSubGoal(data));
                    navigate(`/goals/${data?.parentGoalId}/subgoal/${data.id}`);
                } else {
                    dispatch(resetSelectedSubGoal());
                    dispatch(setSelectedGoal(data));
                    navigate(`/goals/${data.id}`);
                }
            }}>
                <Box className="goalCardContentWrapper">
                    <Box className={'goalCardSection01'}>
                        <Typography className="cardTitle">{data?.name ? data?.name : ''}</Typography>
                        <Typography className="fs14 mb10">{data?.description ? data?.description : ''}</Typography>
                        <Box>
                            <Typography className="cardTitle mb5">{t('MEMBERS')}</Typography>
                            {
                                data?.members?.length > 0 ?
                                <Box sx={{ display: "flex", mb: '10px' }}>
                                    {
                                        data?.members.map((item:any) => {
                                            return(
                                                <Box className={'mr10'}>
                                                    <AvatarAndName 
                                                    avatarName={item?.userName ? item?.userName : ''}
                                                    avatarImage={item?.avatarPath ? baseUrl+'/Content'+item?.avatarPath : ''} />
                                                </Box>
                                            )
                                        })
                                    }
                                </Box> :
                                <Typography>{t('NO_MEMBERS_LABEL')}</Typography>
                            }
                            {
                                !isSubGoal &&
                                <>
                                    <Typography className="cardTitle mb10">{t('SUB_GOALS')}</Typography>
                                    {
                                        data?.subGoals?.length > 0 ?
                                        (
                                            <SubGoalsTable data={data?.subGoals} isLoading={false}
                                            handleChange={(e:any, from:any, item:any) => {e.stopPropagation(); setAddSubGoal(true);}}
                                            isReadOnly={(isAdmin && data?.clubId !== 0) ? true : false} />
                                        ) :
                                        <Box sx={{ mb: '10px' }}>
                                            {/* display: 'flex', justifyContent: 'space-between',  */}
                                            {/* <Typography className="fs14">{t('NO_SUB_GOALS_LABEL')}</Typography> */}
                                            <ButtonDefault
                                            variant={'outlined'}
                                            value={t('ADD_SUB_GOAL')}
                                            manageOnClick={(e:any) => {e.stopPropagation(); setAddSubGoal(true);}}
                                            icon={<FontAwesomeIcon className={'fs13'} icon={faCirclePlus} />}
                                            disabled={(isAdmin && data?.clubId !== 0) ? true : false}
                                            />
                                        </Box>
                                    }
                                </>
                            }
                        </Box>
                    </Box>
                    <Box className={'goalCardSection02'}>
                        <Box className={'mb10'} sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Box sx={{ display: 'flex', }}>
                                <Typography className="fs14 fw700 uppercase mr10">{t('STATUS')+': '}</Typography>
                                <StatusIndicatorSmall reportType={'rabg'} 
                                status={(data?.parentGoalId == null || data?.parentGoalId == 0) && data?.subGoals?.length > 0
                                ? getAverageProjectStatus(statuses) : (data?.status || 4)} />
                            </Box>
                            <Box sx={{ display: 'flex' }}>
                                <Box className={'ml10'}>
                                    <Tooltip title={data?.privacy ? t('PRIVATE') : t('PUBLIC')} className={data?.privacy ? 'closedLock' : 'openLock'} arrow placement="top">
                                        <FontAwesomeIcon className='icon' icon={data?.privacy ? faLock : faLockOpen} onClick={(e:any) => {
                                            e.stopPropagation();
                                            manageDeleteGoal();
                                            }} />
                                    </Tooltip>
                                </Box>
                                <Box className={'ml10'}>
                                    <Tooltip title={t('DELETE')} arrow placement="top">
                                        <FontAwesomeIcon className='icon deleteIcon' icon={faTrashCan} onClick={(e:any) => {
                                            e.stopPropagation();
                                            manageDeleteGoal();
                                            }} />
                                    </Tooltip>
                                </Box>
                            </Box>
                        </Box>
                        {
                            data?.yearFrom != null && data?.yearTo != null &&
                            <Box className={'mb10'} sx={{ display: 'flex' }}>
                                <Typography className="fs14 fw700 uppercase mr10">{t('TIME_PERIOD')+': '}</Typography>
                                <Typography className="fs14">
                                    {`${formatToYear(data?.yearFrom)} - ${formatToYear(data?.yearTo)}`}
                                </Typography>
                            </Box>
                        }
                        <Box className={'mb10'} sx={{ display: 'flex' }}>
                            <Typography className="fs14 fw700 uppercase">{t('DEPARTMENT')+': '}</Typography>
                            <Typography className="fs14 ml10">{(data?.departmentName || data?.departmentId) ? fetchDepartmentName(data?.departmentName || data?.departmentId) : '_'}</Typography>
                        </Box>
                        <Box className={'mb10'} sx={{ display: 'flex' }}>
                            <Typography className="fs14 fw700 uppercase mr10">{data?.clubName && data?.clubName!='' ? t('CLUB')+': ' : t('LEAGUE')+': '}</Typography>
                            <AvatarAndName avatarImage={data?.clubAvatarPath && data?.clubAvatarPath != '' ? `https://jamp.football/Content${data?.clubAvatarPath}` : logo}
                             avatarName={data?.clubName && data?.clubName!='' ? data?.clubName : 'JLeague'} avatarSize={18}/>
                        </Box>
                        <Box sx={{ mr: '20px' }}>
                            {
                                (data?.parentGoalId == null || data?.parentGoalId == 0) &&
                                <CircularWithValueLabel progress={(data?.parentGoalId == null || data?.parentGoalId == 0) && data?.subGoals?.length > 0 ?
                                calculateGoalProgress(statuses) :
                                data?.status != null ? calculateGoalProgress([data?.status]) : 0} 
                                size={100}/>
                            }
                        </Box>
                    </Box>
                </Box>
            </Box>
        </>
    );
}